import React from 'react';
import Button from 'screens/components/basic/Button';
import LOOKUP from 'constants/lookup';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import TextInput from 'screens/components/basic/TextInput';
import SelectInput from 'screens/components/basic/SelectInput';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
import CardSimple from 'screens/components/basic/CardSimple';

const componentName = "InventoryAge";

const Header = (props) => (
    <CardSimple className="p-1">
        <div className="row row_margin_none">
            <div className="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
            <BranchSelectAutoCompleteInput
                                    name={componentName + LOOKUP.report.common.branchName}
                                    label={LOOKUP.report.common.branch + "*"}
                                />
            </div> {/* .col */}
            <div className="col-xs-6 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                <SelectInput
                    name={componentName + "IsCannabis"}
                    defaultValue="2"
                    label={"Type"}
                    floatingLabelText={"Type"}
                    hintText={"Type"}
                    options={props.isCannabisOptions && props.isCannabisOptions.length > 0 ? props.isCannabisOptions : []}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-4 col-lg-2 col-xl-4 m-0">
                <SelectInput
                    name={componentName + LOOKUP.report.common.categoryName}
                    fullWidth={true}
                    label={LOOKUP.report.common.subcategory}
                    floatingLabelText={LOOKUP.report.common.subcategory}
                    hintText={LOOKUP.report.common.subcategory}
                    options={props.productCategoriesOptions && props.productCategoriesOptions.length > 0 ? (props.isCannabis === "0" ? props.productCategoriesOptions.filter(x => !x.isCannabis) : (props.isCannabis === "1" ? props.productCategoriesOptions.filter(x => x.isCannabis) : props.productCategoriesOptions)) : []}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
                <TextInput
                    name={componentName + "ProductName"}
                    floatingLabelText={"Product Name Filter"}
                    hintText={"Product Name Filter"}
                    fullWidth={true}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
                <TextInput
                    name={componentName + "CategoryName"}
                    floatingLabelText={"Category Name Filter"}
                    hintText={"Category Name Filter"}
                    fullWidth={true}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                <TextInput
                    name={componentName + "BrandName"}
                    floatingLabelText={"Brand Name Filter"}
                    hintText={"Brand Name Filter"}
                    fullWidth={true}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pb-2">
                <Button
                    type="IconInButton"
                    className="pull-right mt-1 ml-1 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={props.showBody}
                />
                <Button
                    type="DownloadButton"
                    className="pull-right mt-1 ml-1 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.downloadReport.name}
                    label="Download Report"
                    onTouchTap={props.downloadInventory}
                />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pt-2">
                <p><b>Note: </b><strong className="blue-text"><i>The “Quantity on Hand” only shows the inventory level for that lot number. There may be multiple rows for one product if there are multiple lot numbers for that product.</i></strong></p>
            </div>
        </div>
    </CardSimple>
);

export default Header;
